import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import { RadioGroupProps } from '@mui/material';
import RadioGroup from '../DefaultRadioGroup';

export interface IReactHookFormRadioGroupProps<TFieldValues extends FieldValues> extends Omit<
  RadioGroupProps, 'name' | 'defaultValue'
  >, UseControllerProps<TFieldValues> {}

const ReactHookFormRadioGroup = <
  TFieldValues extends FieldValues
>(props: IReactHookFormRadioGroupProps<TFieldValues>) => {
  const {
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
    ...radioGroupProps
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      shouldUnregister={shouldUnregister}
      render={({
        field: {
          value, onChange, onBlur, ref,
        },
      }) => {
        const { onChange: radioGroupOnChange, ...restRadioGroupProps } = radioGroupProps;
        return (
          <RadioGroup
            {...restRadioGroupProps}
            value={value}
            onChange={(event, val) => {
              onChange(event);
              if (radioGroupOnChange) {
                radioGroupOnChange(event, val);
              }
            }}
            ref={ref}
            onBlur={onBlur}
          />
        );
      }}
    />
  );
};

export default ReactHookFormRadioGroup;
